<template>
  <v-container fluid>
    <v-card class="elevation-3">
      <v-card-title class="body-1">
        {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.PARKING_FINE') }}
        {{ id }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="closeForm()">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="selectedParkingFine">
        <parking-fine-details
          v-if="selectedParkingFine"
          :parking-fine="selectedParkingFine"
        />
        <div
          v-if="
            selectedParkingFine &&
              selectedParkingFine.newParkingFineNumber > 0 &&
              selectedParkingFine.newParkingFine
          "
          class="border-bottom"
          style="border: 1px solid #D9D9D9;"
        />
        <v-row>
          <v-col cols="6">
            <v-data-table
              :headers="[
                {
                  text: $vuetify.lang.t(
                    '$vuetify.ENFORCEMENT.PARKING_FINE_INVOICE_NUMBER'
                  ),
                  align: 'start',
                  sortable: false,
                  value: 'invoiceNumber'
                },
                {
                  text: $vuetify.lang.t(
                    '$vuetify.ENFORCEMENT.PARKING_FINE_INVOICE_DATE'
                  ),
                  align: 'start',
                  sortable: false,
                  value: 'createdAt'
                },
                {
                  text: $vuetify.lang.t(
                    '$vuetify.ENFORCEMENT.PARKING_FINE_AMOUNT'
                  ),
                  align: 'start',
                  sortable: false,
                  value: 'amountInCents'
                },
                {
                  text: 'Pdf',
                  align: 'start',
                  sortable: false,
                  value: 'PDF'
                }
              ]"
              :items="selectedParkingFine.invoices"
              hide-default-footer
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>{{
                    $vuetify.lang.t(
                      '$vuetify.ENFORCEMENT.PARKING_FINE_INVOICES'
                    )
                  }}</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:item.createdAt="props">
                <td>
                  {{ dateEE(props.item.createdAt) }}
                </td>
              </template>
              <template v-slot:item.amountInCents="props">
                <td>
                  {{ props.item.amountInCents / 100 }}{{ props.item.currency }}
                </td>
              </template>
              <template v-slot:item.PDF="props">
                <td>
                  <v-btn text @click="downloadPDF(props.item)">
                    <v-icon small>mdi-file-pdf-box</v-icon>
                    parking-fine-{{ props.item.invoiceNumber }}
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="6">
            <v-data-table
              :headers="[
                {
                  text: $vuetify.lang.t(
                    '$vuetify.ENFORCEMENT.PARKING_FINE_INVOICE_DATE'
                  ),
                  align: 'start',
                  sortable: false,
                  value: 'CreatedAt'
                },
                {
                  text: $vuetify.lang.t('$vuetify.ENFORCEMENT.COMMENT'),
                  align: 'start',
                  sortable: false,
                  value: 'Comment'
                }
              ]"
              :items="selectedParkingFine.commentsArray"
              hide-default-footer
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>{{
                    $vuetify.lang.t('$vuetify.ENFORCEMENT.COMMENTS')
                  }}</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:item.CreatedAt="props">
                <td>
                  {{ dateEE(props.item.CreatedAt) }}
                </td>
              </template>
              <template v-slot:item.Comment="props">
                <td>
                  {{ props.item.Comment }}
                </td>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-toolbar
        v-if="loading.state && loading.type === 'getParkingFine'"
        class="elevation-0"
      >
        <v-spacer></v-spacer>
        <v-progress-circular
          indeterminate
          color="secondary"
        ></v-progress-circular>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import formatDate from '@/mixins/formatDate'

export default {
  name: 'ParkingFineDetailView',
  components: {
    ParkingFineDetails: () =>
      import(
        /* webpackChunkName: "ParkingFineDetails" */ '@/components/enforcement/ParkingFineDetails'
      )
  },
  mixins: [formatDate],
  props: {
    id: String
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('enforcement', ['selectedParkingFine'])
  },
  created() {
    if (this.id > 0) {
      this.getParkingFine(this.id)
    }
  },
  methods: {
    ...mapActions('enforcement', [
      'getParkingFine',
      'getParkingFineInvoicePDF'
    ]),
    closeForm() {
      this.$router.go(-1)
      this.$store.commit('enforcement/setSelectedParkingFine', undefined)
    },
    downloadPDF(invoice) {
      this.getParkingFineInvoicePDF(invoice)
    }
  }
}
</script>
